export default __webpack_public_path__ + "static/media/edit_icon.96686b75.svg";